import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody, MDBContainer, MDBBox, MDBAlert   } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalregister from './Modalregister';
import Modalfinance from './Modalfinance';
import Commentbnlistforuser from './Commentbnlistforuser';
import Commentexlistforuser from './Commentexlistforuser';




export default class Homeuser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            iduser:'',
            article:[],
            articlepay:[],
        };
       
        this.submit = this.submit.bind(this);
        this.list = this.list.bind(this);
       // this.toggle = this.toggle.bind(this);
      }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('https://conference.kpru.ac.th/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('https://conference.kpru.ac.th/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuser.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuserpay.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);

      
    }

    list() {
        this.setState({ iduser: localStorage.getItem('iduser')})


        setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuser.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
             Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticleforuserpay.php?send_id='+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);

      
    }


    render() {

        const date = new Date();
        const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        const dates = day+"-"+month+"-"+year ;

        console.log(dates)


        return (
            <MDBContainer className="mt-1 " fluid>
                <MDBCard>
                    
                    <MDBCardBody>
                        {/* <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1> */}
                      <div className='text-right'><h5>สวัสดีคุณ{localStorage.getItem('nameuser')}</h5></div>  
                        

                      <MDBAlert color="primary" >
                      <MDBBox tag="p"><h4><strong>รายการลงทะเบียนนำเสนอ</strong></h4></MDBBox>
                     </MDBAlert>
                        
                             {/* <div className='mb-2 mt-2'> <Modalregister iduser={this.state.iduser} list={this.list} /></div>   */}

                             <MDBTable bordered responsive>
                                    <MDBTableHead color="grey darken-1" textWhite>
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อบทความ</th>
                                        <th>ผู้นำเสนอ</th>
                                        <th>สาขานำเสนอ</th>
                                        <th>ประเภท</th>
                                        <th>หลักฐาน</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.article.map((article,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{article.send_name}</td>
                                    <td>{article.namepresent}</td>
                                    <td>{article.major_precent}</td>
                                    <td>{article.send_type === '1' ?<> ปากเปล่า</> :<> โปสเตอร์</> }</td>
                                    <td>
                                        {article.send_status === '1' ?<>
                                       <p className="deep-orange-text"><MDBIcon icon="dna" /> อยู่ระหว่างตรวจสอบ</p> 
                                        </>:<>
                                        {article.send_status === '2' ?<> <p className="teal-text"><MDBIcon icon="check" /> ชำระแล้ว</p></>:<>
                                         <Modalfinance id_send={article.id_send} send_id={article.send_id} send_name={article.send_name} list={this.list}  />
                                        </>}
                                        </> }
                                       
                                         </td>
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable>

                            <MDBAlert color="success" >
                            <MDBBox tag="p"><h4><strong>ตรวจสอบสถานะบทความ</strong></h4></MDBBox>
                             </MDBAlert>
   
                    <MDBTable bordered responsive>
                        <MDBTableHead color="grey darken-1" textWhite>
                            <tr>
                            <th>ลำดับ</th>
                            <th>ชื่อบทความ</th>
                            <th>ผู้นำเสนอ</th>
                            <th>สาขานำเสนอ</th>
                            <th>ประเภท</th>
                            <th>ข้อเสนอแนะบรรณาธิการ</th>
                            <th>ข้อเสนอแนะผู้ทรงคุณวุฒิ</th>
                            <th>สถานะ</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                        {this.state.articlepay.map((articlepay,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articlepay.send_name}</td>
                        <td>{articlepay.namepresent}</td>
                        <td>{articlepay.major_precent}</td>
                        <td>{articlepay.send_type === '1' ?<> ปากเปล่า</> :<> โปสเตอร์</> }</td>
                        <td>
                          <Commentbnlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/>
                          </td>
                        <td><Commentexlistforuser  id_send={articlepay.id_send} iduser={this.state.iduser}/></td>
                        <td>{articlepay.stapat === '3'?<>    <MDBAlert color="success">
        <a href="#!" className="alert-link">ผ่านการพิจารณา</a>
      </MDBAlert></>:<><MDBAlert color="warning">
        <a href="#!" className="alert-link">อยู่ระหว่างการพิจารณา</a>
      </MDBAlert></>}

      {/* {articlepay.stapat === '3'?<>   
      <MDBBtn color="secondary" size="sm" href={'https://edu.kpru.ac.th/conference/PHPAPI/TCPDF-main/certificate.php?id_sendcf='+articlepay.id_send } target="_blank"> ดาวน์โหลดเกียรติบัตร</MDBBtn>
      </>:<></>} */}
      </td>
                        </tr>
                      )}
                           
                        </MDBTableBody>
                    </MDBTable>

                        {/* <form onSubmit={this.submit}>
                            <div className="mb-2">
                                <label>ชื่อจริง</label>
                                <input className="form-control" onChange={this.onTextChange} name="name"
                                    value={this.state.name} placeholder="กรุณาระบุชื่อจริง" required />
                            </div>

                            <div className="mb-2">
                                <label>นามสกุล</label>
                                <input className="form-control" onChange={this.onTextChange} name="lname"
                                    value={this.state.lname} placeholder="กรุณาระบุนามสกุล" required />
                            </div>

                            <div className="mb-2">
                                <label>อายุ</label>
                                <input type="number" className="form-control" onChange={this.onTextChange} name="age"
                                    value={this.state.age} placeholder="กรุณาระบุอายุ" required />
                            </div>

                            <div className="mb-2">
                                <label>เพศ</label>
                                <input className="form-control" onChange={this.onTextChange} name="sex"
                                    value={this.state.sex} placeholder="กรุณาระบุเพศ" required />
                            </div>

                            <div className="mt-3">
                                <MDBBtn type="submit" color="primary"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                            </div>


                        </form> */}
                 <h3>ช่องทางชำระเงิน</h3>   
                 <h5>ชื่อบัญชี : เงินรายได้จากการจัดบริการ มหาวิทยาลัยราชภัฏกำแพงเพชร</h5>     
                  <h5>ธนาคาร : กรุงไทย</h5>     
                  <h5>เลขบัญชี : 347-3-05071-7</h5>  
                    </MDBCardBody>
                   <hr/>
                 

                    {/* <img src="https://conference.kpru.ac.th/PHPAPI/rerip.png" className="rounded mx-auto d-block w-50" alt="aligment" /> */}
                </MDBCard>
                </MDBContainer>
        )
    }
}

